
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4a3428"}},[_c('path',{attrs:{"d":"m23.8896 14.5823-6.1272-4.89678c-.0323-.02584-.0706-.04144-.1106-.04506s-.0801.00488-.1159.02455c-.0358.01966-.0658.04973-.0869.08686-.021.03713-.0321.07986-.0321.12344v2.30309h-7.1832c-.082.0001-.1606.0355-.2186.0985-.05798.0631-.09054.1485-.09054.2376v4.6159c-.00004.0441.00793.0878.02345.1286s.03828.0779.06699.1091c.0287.0312.0628.056.1003.0729.0376.0169.0778.0256.1184.0256h7.1832v2.297c0 .0435.0111.0863.0321.1234.0211.0371.0511.0672.0869.0869.0358.0196.0759.0281.1159.0245s.0783-.0192.1106-.045l6.1272-4.8965c.0343-.0273.0623-.063.0815-.1043.0192-.0412.0292-.0868.0292-.133s-.01-.0918-.0292-.133c-.0192-.0413-.0472-.077-.0815-.1043z"}}),_c('path',{attrs:{"d":"m15.0738 8.55443v2.24267h-.6764v-1.84273h-7.49064v-2.72956l-4.9472 3.95479 4.9472 3.9544v-2.0437h.6764v3.0328c-.00005.0435-.0112.0862-.03221.1233-.02101.0372-.05107.0672-.08684.0869s-.07586.0282-.11583.0247c-.03996-.0036-.07824-.0191-.11059-.0448l-6.12698-4.8968c-.03431-.0273-.06221-.063-.08145-.1042s-.02926-.0867-.02926-.1329.01002-.0918.02926-.133.04714-.07691.08145-.10421l6.12726-4.89645c.03231-.02575.07055-.04127.11048-.04484.03993-.00358.08.00493.11575.02459s.06579.04969.08679.08677.03213.07975.03217.12328v2.98282h7.18324c.0817.00056.1599.03623.2175.09921s.0899.14817.0899.23696z","stroke":"#4a3428","stroke-linejoin":"round","stroke-width":".3"}})])])
          )
        }
      }
    